<template>
  <div
    class="principle-item-main"
    :ref="data.key"
    :class="{ 'principle-item-main-mobile': isMobile }"
  >
    <div class="principle-item-content" :class="data.className">
      <div class="left animate__animated" :class="animated">
        <div class="title">{{ data.title }}</div>
        <div class="content">{{ data.content }}</div>
      </div>
      <div
        class="right animate__animated"
        :class="animated"
        :style="{ backgroundImage: `url(${data.icon})` }"
      ></div>
    </div>
  </div>
</template>
<script>
import { isElementNotInViewport } from "@/utils/common.js";
export default {
  name: "PrincipleItem",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    animated: {
      type: String,
      default: "animate__zoomIn",
    },
  },
  data() {
    return {
      left: false,
      right: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      if (!isElementNotInViewport(this.$refs[this.data.key])) {
        this.left = true;
        this.right = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.principle-item-main {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  .principle-item-content {
    width: calc($multiple * 1040px);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.left {
  .title {
    font-size: calc($multiple * 20px);
    font-family: PingFangTC-Medium, PingFangTC;
    font-weight: 500;
    color: #030303;
    line-height: calc($multiple * 28px);
    letter-spacing: 1px;
    margin-bottom: calc($multiple * 10px);
  }
  .content {
    width: calc($multiple * 518px);
    font-size: calc($multiple * 14px);
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.8);
    line-height: calc($multiple * 37px);
    letter-spacing: 1px;
  }
}
.right {
  flex-shrink: 0;
  width: calc($multiple * 387px);
  height: calc($multiple * 403px);
  background-repeat: no-repeat;
  background-size: 100%;
}
.custom-class {
  flex-direction: row-reverse;
}
.principle-item-main-mobile {
  padding: 1.54rem 1rem 0.51rem !important;
  .left {
    .title {
      font-size: 0.72rem;
      font-family: PingFangTC-Medium, PingFangTC;
      font-weight: 500;
      color: #000000;
      line-height: 1.02rem;
      margin-bottom: 0.61rem;
    }
    .content {
      max-width: 7.99rem;
      font-size: 0.61rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.8);
      line-height: 0.98rem;
      letter-spacing: 0.05rem;
    }
  }
  .right {
    flex-shrink: 0;
    width: 8.5rem;
    height: 8.81rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
// .left {
//   padding-left: 3.63rem;
//   margin-right: 1.72rem;
//   .title {
//     font-size: 0.35rem;
//     font-family: PingFangTC-Medium, PingFangTC;
//     font-weight: 500;
//     color: #030303;
//     line-height: 0.49rem;
//     letter-spacing: 0.03rem;
//     margin-bottom: 0.37rem;
//   }
//   .content {
//     width: 6.23rem;
//     font-size: 0.24rem;
//     font-family: PingFangTC-Regular, PingFangTC;
//     font-weight: 400;
//     color: #000000;
//     line-height: 0.49rem;
//     letter-spacing: 1px;
//   }
// }
// .right {
//   flex-shrink: 0;
//   width: 5.16rem;
//   height: 5.37rem;
//   background-repeat: no-repeat;
//   background-size: 100%;
// }
// .custom-class {
//   flex-direction: row-reverse;
//   .left {
//     margin-right: 3.93rem;
//     padding-left: 1.45rem;
//   }
//   .content {
//     width: 6.4rem;
//   }
// }
// .principle-main-mobile {
//   display: flex;
//   align-items: center;
//   flex-direction: row-reverse;
//   width: 100%;
//   height: 10.58rem;
//   padding-left: 0rem;
//   .left {
//     margin-right: 1.89rem;
//     .title {
//       font-size: 0.82rem;
//       font-family: PingFangTC-Medium, PingFangTC;
//       font-weight: 500;
//       color: #000000;
//       line-height: 1.13rem;
//     }
//     .content {
//       width: 10.5rem;
//       font-size: 0.61em;
//       font-family: PingFangTC-Regular, PingFangTC;
//       font-weight: 400;
//       color: #8b8b8b;
//       line-height: 0.98rem;
//       letter-spacing: 0.05rem;
//       opacity: 1;
//     }
//   }
//   .right {
//     margin-bottom: 1rem;
//     margin-right: 1.38rem;
//     flex-shrink: 0;
//     width: 4.35rem;
//     height: 4.97rem;
//     background-repeat: no-repeat;
//     background-size: 100%;
//   }
//   &.custom-class {
//     flex-direction: row;
//     .left {
//       margin-right: 1.13rem;
//       margin-left: 1.02rem;
//       text-align: left;
//     }
//     .content {
//       width: 11.21rem;
//       text-align: left;
//     }
//   }
// }
</style>
